module.exports = __webpack_public_path__ + "static/img/dj_loop_05.d151514.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dj/dj_loop_05.png
// module id = NKeT
// module chunks = 1